import React from 'react';
import { Grid, Input } from 'semantic-ui-react';

export const InputsText = () => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <h4>Text Inputs</h4>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row columns={3} className="style-guide--group">
      <Grid.Column>
        <Input placeholder="Suggest Text" />
      </Grid.Column>
      <Grid.Column>
        <Input className="input--active" value="Active Field" />
      </Grid.Column>
      <Grid.Column>
        <Input value="Completed Field" />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <h4>Full Width Text Inputs</h4>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row columns={3} className="style-guide--group">
      <Grid.Column>
        <Input className="input--full" placeholder="Suggest Text" />
      </Grid.Column>
      <Grid.Column>
        <Input className="input--active input--full" value="Active Field" />
      </Grid.Column>
      <Grid.Column>
        <Input className="input--full" value="Completed Field" />
      </Grid.Column>
    </Grid.Row>
  </Grid>
);



// WEBPACK FOOTER //
// ./src/pages/styleguide/components/Forms/inputs-text.js